import { Icon } from "@iconify/react/dist/iconify.js";
import React, { useEffect, useState } from "react";
//import { SignUpContext } from "../AuthContext/SignUpContext";
import { toast,ToastContainer } from 'react-toastify';
import axios from 'axios';
import { uploadFilesToImageService } from "../utils/uploadService";


const roles = [
  { id: "admin", name: "admin" },
  { id: "CRO", name: "CRO" },
  { id: "DFO", name: "DCF" },
];

const UserUpdateLayerCustom = ({ userId }) => {
  //const useSignUp = useContext(SignUpContext);
  //const { signup } = useSignUp;
  const API_BASE_URL = process.env.REACT_APP_BE_API_URL;
  const [departments, setDepartments] = useState([]);
  const [signUpData, setSignUpData] = useState({
    firstname: "",
    lastname: "",
    phoneno: "",
    email: "",
    address: "",
    role: "",
    department: "",
    emergency_contact_name: "",
    emergency_contact_number: "",
    emergency_contact_address: "",
    imageUrl: "",
  });

  const [imagePreviewUrl, setImagePreviewUrl] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  // Fetch user data by ID
  useEffect(() => {
    const fetchUserData = async () => {
      try {
        const token = localStorage.getItem("token");
        const response = await axios.get(`${API_BASE_URL}/backend/users/get-user-by-id/${userId}`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        if (response.data.status) {
          const userData = response.data.data;
          setSignUpData({
            firstname: userData.first_name || "",
            lastname: userData.last_name || "",
            phoneno: userData.phone_no || "",
            email: userData.email || "",
            address: userData.address || "",
            role: userData.role || "",
            department: userData.department || "",
            emergency_contact_name: userData.emergency_contact_name || "",
            emergency_contact_number: userData.emergency_contact_number || "",
            emergency_contact_address: userData.emergency_contact_address || "",
            imageUrl: userData.imageUrl || "",
          });
          setImagePreviewUrl(userData.imageUrl || ''); // Set image preview if available
        }
      } catch (error) {
        toast.error("Failed to fetch user data.");
        console.error("Error fetching user data:", error);
      }
    };

    if (userId) {
      fetchUserData();
    }
  }, [userId,API_BASE_URL]);

  const handleImageChange = async (e) => {
    const file = e.target.files[0];
    if (!file) return;

    try {
      const uploadedItems = await uploadFilesToImageService(file, {
        folder: 'survey-2026',
      });
      const imageUrl = uploadedItems[0]?.url;

      if (!imageUrl) {
        throw new Error('Image upload failed');
      }

      setImagePreviewUrl(imageUrl);
      setSignUpData(prevData => ({
        ...prevData,
        imageUrl
      }));

      toast.success('Image uploaded successfully');
    } catch (error) {
      console.error('Image upload error:', error);
      toast.error('Failed to upload image');
    }
  };
  useEffect(() => {
      const fetchDepartments = async () => {
        try {
          const token = localStorage.getItem("token");
          const response = await axios.get(`${process.env.REACT_APP_BE_API_URL}/backend/departments/get-all-departments`, {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          });
          setDepartments(response.data.data);
        } catch (error) {
          toast.error("Failed to fetch departments.");
          console.error("Error fetching departments:", error);
        }
      };
      fetchDepartments();
    }, []);
  const handleSignUpChange = (e) => {
    const { name, value } = e.target;
    setSignUpData(prevData => ({
      ...prevData,
      [name]: value
    }));
  };

  const handleSignUp = async (e) => {
    e.preventDefault();
    setIsLoading(true);

    try {
      const backendData = {
        first_name: signUpData.firstname,
        last_name: signUpData.lastname,
        phone_no: signUpData.phoneno,
        email: signUpData.email,
        address: signUpData.address,
        role: signUpData.role,
        department: signUpData.department,
        emergency_contact_name: signUpData.emergency_contact_name,
        emergency_contact_number: signUpData.emergency_contact_number,
        emergency_contact_address: signUpData.emergency_contact_address,
        imageUrl: signUpData.imageUrl,
      };
      const token = localStorage.getItem("token");
      const response = await axios.put(
        `${API_BASE_URL}/backend/users/${userId}`,
        backendData,
        {
          headers: {
            'Authorization': `Bearer ${token}`,
        },
        }
      );
     if (response.data.status) {
        toast.success(response.data.message || "User updated successfully!");
      } else {
        toast.error(response.data.message || "Failed to update user.");
      }
    } catch (error) {
      console.error("Update error:", error);
      toast.error(error.response?.data?.message || "An error occurred while updating the user.");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="col-lg-12 col-md-12 col-sm-12">
      <form onSubmit={handleSignUp}>
        <div className="text-center mb-6">
          <h6 className="mb-4 text-3xl font-extrabold text-gray-800 flex items-center justify-center bg-gray-100 p-4 rounded-lg shadow-md">
            <Icon icon="mdi:account-edit" className="text-4xl mx-3 my-1" />
            Update User Form
          </h6>
        </div>
        <ToastContainer />
        <div className="row gy-3">
          {[
            { label: "First Name", name: "firstname", icon: "mdi:account" },
            { label: "Last Name", name: "lastname", icon: "mdi:account" },
            { label: "Phone Number", name: "phoneno", icon: "mdi:phone" },
            { label: "Email", name: "email", icon: "mdi:email", type: "email" },
            { label: "Emergency Contact Name", name: "emergency_contact_name", icon: "mdi:account" },
            { label: "Emergency Contact Number", name: "emergency_contact_number", icon: "mdi:phone" },
            { label: "Emergency Contact Address", name: "emergency_contact_address", icon: "mdi:home" },
          ].map(({ label, name, icon, type = "text" }) => (
            <div className="col-lg-4 col-md-6 col-sm-12" key={name}>
              <label className="form-label d-flex align-items-center gap-2">
                <Icon icon={icon} className="text-lg" />
                {label}
              </label>
              <input
                type={type}
                name={name}
                value={signUpData[name]}
                onChange={handleSignUpChange}
                className="form-control h-56-px bg-neutral-50 radius-12 shadow-sm"
                placeholder={label}
                required={name !== "emergency_contact_address"} // Make optional if needed
              />
            </div>
          ))}

          <div className="col-lg-4 col-md-6 col-sm-12">
            <label className="form-label d-flex align-items-center gap-2">
              <Icon icon="mdi:office-building" className="text-lg" />
              Department
            </label>
            <select
              name="department"
              value={signUpData.department}
              onChange={handleSignUpChange}
              className="form-control h-56-px bg-neutral-50 radius-12 d-flex align-items-center shadow-sm"
              required
            >
              <option value="">Select Department</option>
              {departments.map((dept) => (
                <option key={dept.id} value={dept.id}>
                  {dept.name}
                </option>
              ))}
            </select>
          </div>

          <div className="col-lg-4 col-md-6 col-sm-12">
            <label className="form-label d-flex align-items-center gap-2">
              <Icon icon="mdi:account-star" className="text-lg" />
              Role
            </label>
            <select
              name="role"
              value={signUpData.role}
              onChange={handleSignUpChange}
              className="form-control h-56-px bg-neutral-50 radius-12 d-flex align-items-center shadow-sm"
              required
            >
              <option value="">Select Role</option>
              {roles.map((role) => (
                <option key={role.id} value={role.id}>
                  {role.name}
                </option>
              ))}
            </select>
          </div>

          <div className="col-lg-4 col-md-6 col-sm-12">
            <label className="form-label d-flex align-items-center gap-2">
              <Icon icon="mdi:home" className="text-lg" />
              Address
            </label>
            <textarea
              name="address"
              className="form-control bg-neutral-50 radius-12 shadow-sm"
              rows={4}
              placeholder="e.g., House No. 123, Street No. 4, Forest Colony Lahore"
              value={signUpData.address}
              onChange={handleSignUpChange}
              required
            />
          </div>

          <div className="mb-24 mt-16 col-lg-4 col-md-6 col-sm-12">
            <div className="avatar-upload">
              <div className="avatar-edit position-absolute bottom-0 end-0 me-24 mt-16 z-1 cursor-pointer">
                <input
                  type="file"
                  id="imageUpload"
                  accept=".png, .jpg, .jpeg"
                  hidden
                  onChange={handleImageChange}
                />
                <label
                  htmlFor="imageUpload"
                  className="w-32-px h-32-px d-flex justify-content-center align-items-center bg-primary-50 text-primary-600 border border-primary-600 bg-hover-primary-100 text-lg rounded-circle">
                  <Icon icon="solar:camera-outline" className="icon"></Icon>
                </label>
              </div>
              <div className="avatar-preview">
                <div
                  id="imagePreview"
                  style={{
                    backgroundImage: imagePreviewUrl ? `url(${imagePreviewUrl})` : 'none',
                    backgroundColor: !imagePreviewUrl ? '#f0f0f0' : 'transparent'
                  }}
                >
                  {!imagePreviewUrl && (
                    <div className="d-flex justify-content-center align-items-center h-100">
                      <Icon icon="mdi:account" className="text-4xl text-gray-400" />
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="d-flex justify-content-end">
          <button
            className="btn btn-success text-sm btn-sm px-6 py-12 radius-12 my-24 mx-10 col-lg-3 col-md-6 col-sm-12"
            type="submit"
            disabled={isLoading}
          >
            {isLoading ? 'Updating...' : 'Update User'}
          </button>
        </div>
      </form>
    </div>
  );
};

export default UserUpdateLayerCustom;
